import { useHeight } from "./useHeight";
import { useDebugValue } from "react";
export function useMaxItems(options) {
    const { wait, itemHeight, divider, dividerHeight = divider ? 1 : 0, staticHeight = 0 } = options;
    const [listRef, listHeight] = useHeight(wait);
    const maxItems = listHeight &&
        Math.floor((listHeight + dividerHeight - staticHeight) / (itemHeight + dividerHeight));
    useDebugValue(maxItems);
    return [listRef, maxItems];
}
//# sourceMappingURL=useMaxItems.js.map